export default "__VITE_ASSET__CtIUHE2b__"